export default "__VITE_ASSET__COkrc276__"